var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ec-compare-remove-button",attrs:{"href":"#"},on:{"click":function($event){_vm.remove()}}},[_c('i',{staticClass:"ec-icon ec-icon-cross"})])}
var staticRenderFns = []

export { render, staticRenderFns }